import { RouteItem } from '@eastcoal/router/types/route'

import { HOUSE_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const houseAuctionCreateRoute: RouteItem = {
  title: '新增竞拍（房屋）',
  hideInMenu: true,
  path: HOUSE_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
